import { LegendStates, MouseSelectionStates, SelectedParams } from "types";
import { SeriesType } from "types/echarts";

import { getSeriesIndex, isValidChartLegendStates } from "./utils";

export function stackedBarHoverLegends({
  params,
  series
}: Partial<MouseSelectionStates>) {
  const seriesIndex = params.seriesIndex;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const s = series as any;
  if (!s?.[seriesIndex]?.name) {
    return {
      hoverLegendItem: "",
      hoverLegendGroup: "",
      hoverLegendId: ""
    };
  }
  const seriesName = s?.[seriesIndex]?.name;

  return {
    hoverLegendItem: seriesName,
    hoverLegendGroup: seriesName,
    hoverLegendId: ""
  };
}

export function stackedBarSelectionParams({
  states,
  series
}: Partial<LegendStates>): SelectedParams {
  const { hoverLegendGroup, hoverLegendItem, attentionWells } = states;
  isValidChartLegendStates({ states, series });

  const isHoveringOnBins =
    hoverLegendItem && !hoverLegendGroup && attentionWells?.length === 0;

  const seriesIndex = getSeriesIndex({ states, series });

  if (isHoveringOnBins) {
    return {
      seriesIndex: [...seriesIndex],
      seriesType: SeriesType.Bar,
      targetIndex: undefined
    };
  }
}
